<template>
  <Common>
    <template #transport>
      <h2>{{$t('track.trackWay.belarus.h2')}}</h2>
    </template>

    <!-- <template #pay>
      <h3>{{$t('track.trackWay.belarus.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.belarus.pay.p1')}}<br />
        {{$t('track.trackWay.belarus.pay.p2')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";
export default {
  components: { Common },
};
</script>

<style lang="less" scoped>
</style>